import Layout from 'components/layout';
import SEO from 'components/seo';
import React from 'react';
import Style from 'styles/tokushoho.module.scss';

const Tokushoho = () => {
  return (
    <Layout>
      <SEO title='特定商取引法に基づく表記' path='tokushoho' />
      <div className={Style.container}>
        <div className={Style.ctIntro}>
          <div className={Style.ctIntro__inner}>
            <h1 className={Style.ctIntro__title}>特定商取引法に基づく表記</h1>
          </div>
        </div>
        <section className={Style.tokushoho__body}>
          <dl>
            <dt>事業者</dt>
            <dd>株式会社イーゼ</dd>
            <dt>運営責任者</dt>
            <dd>石井 幸治</dd>
            <dt>所在地</dt>
            <dd>〒101-0052東京都千代田区神田小川町3-6-1栄信ビル7階</dd>
            <dt>電話番号</dt>
            <dd>03-5244-5955</dd>
            <dt>メールアドレス</dt>
            <dd>comachi_operation@e-ize.jp</dd>
            <dt>ホームページ</dt>
            <dd>
              <a style={{ textDecoration: 'underline' }} href='https://e-ize.jp/' target='_blank'>
                https://e-ize.jp/
              </a>
            </dd>
            <dt>購入可能な範囲の制限</dt>
            <dd>特にございませんが、日本の国内法に準じてご利用していただきます。</dd>
            <dt>注文方法</dt>
            <dd>インターネット</dd>
          </dl>
          <h2 className={Style.tokushoho__body__title}>comachicartに関して</h2>
          <dl>
            <dt>■ サービス利用料等（2026年2月リリース以降の新プラン）</dt>
            <dd>
              ・月額費用はご契約プランにより異なります。
              <ul>
                <li>・スタートアッププラン：0円</li>
                <li>・ベーシックプラン：4,000円<sup>※1</sup></li>
                <li>・プロフェッショナルプラン：8,000円<sup>※1</sup></li>
              </ul>
              ・システム利用料として、各販売ごとの売上（送料及び消費税を含む）に対して以下の料率をいただきます。
              <ul>
                <li>・スタートアッププラン：2.5%<sup>※2</sup></li>
                <li>・ベーシックプラン：0%</li>
                <li>・プロフェッショナルプラン：0%</li>
              </ul>
              ・クレジットカード決済を行う場合は、決済手数料として以下の費用が発生します。
              <ul>
                <li>・3.2%<sup>※3</sup>（VISA / Mastercard）</li>
                <li>・3.3%<sup>※3</sup>（American Express / JCB / Diners Club）</li>
              </ul>
              ・請求書記載の所定の期日までにお支払いいただきます。
            </dd>
          </dl>
          <dl className={Style.tokushoho__body__legacy}>
            <dt>■ 既存プランをご利用の店舗様（旧プラン）</dt>
            <dd>
              ・月額費用は0円～となります。
              <br />
              ・システム利用料として、各販売ごとの売上（送料及び消費税を含む）に対して～3%<sup>※2</sup>をいただきます。
              <br />
              ・クレジットカード決済を行う場合は、サービス利用料として、以下の費用が発生します。
              <ul>
                <li>・月額費用：0円～</li>
                <li>・決済手数料：3.5%<sup>※3</sup></li>
                <li>・売上処理料：0円</li>
              </ul>
            </dd>
          </dl>
          <div className={Style.tokushoho__body__notes}>
            <p className={Style.tokushoho__body__annotation}>※1　月額費用は税込価格となります。</p>
            <p className={Style.tokushoho__body__annotation}>※2　システム利用料は税込価格となります。</p>
            <p className={Style.tokushoho__body__annotation}>※3　決済手数料は税抜価格となります。</p>
            <p className={Style.tokushoho__body__annotation}>
              最新の料金プランの詳細は{' '}
              <a style={{ textDecoration: 'underline' }} href='https://www.comachicart.jp/price/' target='_blank'>
                https://www.comachicart.jp/price/
              </a>
              {' '}をご参照ください。
            </p>
          </div>
          <dl>
            <dt>■ 利用可能な決済手段</dt>
            <dd>
              ・クレジットカード：Visa、Mastercard、JCB、American Express
              <br />
              ・銀行振込
            </dd>

            <dt>■ 商品の引渡し時期</dt>
            <dd>サービスに登録後、即日ご利用いただけます。</dd>

            <dt>■ 返金・キャンセル</dt>
            <dd>返金、キャンセルは受け付けておりません。</dd>
          </dl>
        </section>
      </div>
    </Layout>
  );
};

export default Tokushoho;
